import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class HotjarService {
  constructor(@Inject(DOCUMENT) private document: Document) { }

  initHotjar(siteId: string) {
    if ((window as any).hj) {
      return;
    }
    
    const script = this.document.createElement('script');
    script.innerHTML = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${siteId},hjsv:6};
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `;
    
    this.document.head.appendChild(script);
    
    const mainScript = this.document.createElement('script');
    mainScript.async = true;
    mainScript.src = `https://static.hotjar.com/c/hotjar-${siteId}.js?sv=6`;
    this.document.head.appendChild(mainScript);
  }
  
  triggerEvent(eventName: string) {
    if ((window as any).hj) {
      (window as any).hj('trigger', eventName);
    }
  }
}